import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import type {RootState} from "../../../app/store";
import {NavLink, useNavigate} from "react-router-dom";
import { paths } from "../../../app/routes/paths";
import { useRolePath } from "../../../app/routes/useRolePath";
import {useEffect, useState, type ReactNode} from "react";
import {Formik} from "formik";
import Form from 'react-bootstrap/Form';
import axios from "axios";
import request from "axios";
import {uploadUser} from "../../../app/reducers/authorization-slice";
import {hideMessage, setMessage} from "../../../app/reducers/message-slice";

const WebSite = ({ children }: { children?: ReactNode }) => {
    const {t, i18n} = useTranslation();
    const user = useSelector((state: RootState) => state.authorization.user || {})
    const [isFormVisible, setVisibleForm] = useState(false);
    const navigate = useNavigate();
    const to = useRolePath();
    const dispatch = useDispatch()
    //const [isMessage, setMessage] = useState(null)

    const generateWebSite = async ({website}) => {
        const {REACT_APP_API_HOST} = process.env
        const response: any = await request.put(`${REACT_APP_API_HOST}/users/${user.id}`, {
            website
        })
        if (response.status !== 200) return;

        dispatch(uploadUser(response.data))
    }

    const openToWebSite = async (website) => {
        window.open(`/web-sites/${website}`,'_blank')
    }

    const makeProfWebSite = () => {
        navigate(to(paths.webBuilder));
    }

    useEffect(() => {
        if (!user) return
        console.log('USER', user)
        //user.website
    }, []);

    return (
        <div className="web-site">
            <h1 className='title text-center'>{t('web-site.title')}</h1>

            <h2 className="description mb-16 border p-16 br-8 fs-5">
                {t('web-site.description')}
            </h2>

            <div className='d-flex mb-5'>
                <div className='mr-12'>
                    <button className='btn btn-info'
                            onClick={() => {
                                if (!user.website) setVisibleForm(true)
                            }}>{t('web-site.button.generate')}</button>
                </div>
                <div className='d-flex flex-column'>
                    <button className='btn btn-primary mb-1'
                            onClick={makeProfWebSite}>{ t('web-site.button.proff') }</button>
                    <span>{t('web-site.access-in-plan')} <NavLink to={`${to(paths.dashboard)}#choose-plan`}>{t('web-site.change')}</NavLink> </span>
                </div>
            </div>

            {user.website && <div>
                {t(`Your website has been title`)}: {user.website}
            </div>}

            {user.website && isFormVisible &&
                <div>
                    <p>Заповніть форму</p>
                    <Formik<any>
                        initialValues={{website: ''}}
                        validate={values => {
                            const errors = {};
                            if (!values.website) errors.website = 'Required';

                            return errors;
                        }}
                        onSubmit={async (values, {setSubmitting}) => {
                            await generateWebSite(values)
                            dispatch(setMessage({
                                value: 'Web site generated successfully.',
                                timeout: 3000
                            }))
                        }}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                              /* and other goodies */
                          }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-2 form-group">
                                    <div className="col-12">
                                        <Form.Label htmlFor="website">{t('web-site.form.title')}</Form.Label>
                                        <Form.Control
                                            id="website"
                                            className={`form-control ${errors.website && touched.website ? 'is-invalid' : ''}`}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.website}></Form.Control>
                                    </div>
                                </div>
                                <button className='btn btn-primary'
                                        type="submit"
                                        disabled={isSubmitting}>{t('web-site.go')}</button>
                            </form>
                        )}
                    </Formik>
                </div>}

            {user.website && <button className='btn btn-primary'
                                     onClick={() => openToWebSite(user.website)}>{t('web-site.link')}</button>}
        </div>
    )
}

export default WebSite